// extracted by mini-css-extract-plugin
export default {"formWrapper":"ChangeLeadStateModal_formWrapper__XB7v7"};